import { useEffect, useRef, useState } from "react";
import styles from "./PanierSummary.module.css";
import TrashIcon from "assets/icons/trash";
import Button from "./Button";
import api from "services/api";
import { useCart } from "contexts/CartContext";
import { useAuth } from "contexts/AuthContext";
import { Route } from "react-router-dom";
import Spinner from "./Spinner";

const PanierSummary = ({ addressId, CGVAccepted, onSubmit }) => {

  const { isLoggedIn } = useAuth();
  const { cartItems, cartQuantityForEachDate, removeFromCart, relaodCart, addToCart, emptyCart, checkDisponibility } = useCart();


  const divRef = useRef(null);

  useEffect(() => {
    /* if (divRef.current && addressId) {
      divRef.current.scrollIntoView({ behavior: "smooth" });
    } */
  }, [addressId]);


  return (
    <div className={styles.cartSummary}>
      <div className={styles.cartTitle}>
        Détails de la commande
      </div>
      <p className={styles.description}>
        Seul le paiement par Carte bancaire est autorisé. En cliquant sur <span className={styles.attention}>Régler ma commande</span>, vous serez redirigé vers le module de paiement sécurisé de notre partenaire bancaire.
      </p>
      <ul className={styles.cartList}>
        {cartItems.map(item => <li>
          <div className={styles.ProductImage}>
            <img src={item.poster ? item.poster.path : ""} alt="" />
          </div>
          <div className={styles.ProductInfo}>
            <div className={styles.ProductTitle}>{item.spectacleName}</div>
            <div className={styles.ProductDescription}>{item.tarifName}</div>
            <div className={styles.ProductDate}>{item.dateLongue + " à " + item.heure}</div>
            <div className={styles.ProductDescription}>{item.lieu + ", " + item.ville}</div>
            <div className={styles.ProductPrice}>
              {(() => {
                const price = item.prixUnitaire;
                const amount = price * item.quantite;
                return amount;
              })().toFixed(2).replace('.', ',')} €
            </div>
          </div>
          <div className={styles.ProductAction}>
            <div className={styles.ProductDelete}
              onClick={() => {
                removeFromCart({ itemId: item.id }).then(() => {
                  relaodCart();
                });
              }}>
              <TrashIcon />
            </div>
          </div>
        </li>)}
      </ul>
      <div ref={divRef} className={styles.cartTotal}>
        TVA : 0.00 €
      </div>
      <div ref={divRef} className={styles.cartTotal}>
        Total TTC : {
          (() => {
            const total = cartItems.reduce((acc, item) => {
              const price = item.prixUnitaire;
              return acc + (price * item.quantite);
            }, 0);
            return total;
          })().toFixed(2).replace('.', ',')} €
      </div>
      <Button 
        disabled={!CGVAccepted || !addressId} 
        onClick={() => {
          console.log("🎯 DEBUG: Bouton 'Régler votre commande' cliqué", {
            CGVAccepted,
            addressId,
            disabled: !CGVAccepted || !addressId
          });
          if (onSubmit) {
            onSubmit();
          } else {
            console.error("❌ DEBUG: onSubmit est undefined!");
          }
        }}
      >
        Régler votre commande
      </Button>
    </div>
  );
}

export default PanierSummary;
